import React from 'react';
import { FieldPath, FieldValues, useController, UseControllerProps } from 'react-hook-form';
import { CheckboxField as OriginalCheckboxField } from '@wheely/ui-kit';

interface IProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>
  extends UseControllerProps<TFieldValues, TName>,
    Omit<
      React.ComponentProps<typeof OriginalCheckboxField>,
      'name' | 'checked' | 'onChange' | 'error' | 'defaultValue'
    > {}

const CheckboxField = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  rules,
  control,
  defaultValue,
  shouldUnregister,
  ...checkboxProps
}: IProps<TFieldValues, TName>) => {
  const {
    field: { onChange, value, ref, ...field },
    fieldState: { error },
  } = useController({
    name,
    rules,
    control,
    defaultValue,
    shouldUnregister,
  });

  const handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    onChange(event.currentTarget.checked);
  };

  return (
    <OriginalCheckboxField
      {...field}
      {...checkboxProps}
      inputRef={ref}
      name={name}
      checked={Boolean(value)}
      onChange={handleChange}
      error={error?.message}
    />
  );
};

export { CheckboxField };
